import { APP_ENV } from './utils';

export default {
  appEnv: process.env.APP_ENV,
  nodeEnv: process.env.NODE_ENV,
  appDeployEnv: APP_ENV,
  appVersion: '1.0.0',
};
